import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Inject dynamic canonical tag for SEO to avoid duplicate content penalties
const canonicalLink = document.createElement("link");
canonicalLink.rel = "canonical";
canonicalLink.href = window.location.origin + window.location.pathname;
document.head.appendChild(canonicalLink);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
